export function calculateSvgScale(el: SVGElement) {
  const viewBox = el.getAttribute('viewBox');
  if (!viewBox) {
    return 1;
  }

  const [_vX, _vY, vW, vH] = viewBox.split(' ').map(Number);

  const { width: elW, height: elH } = el.getBoundingClientRect();

  const scaleX = vW / elW;
  const scaleY = vH / elH;

  const scale = Math.max(scaleX, scaleY);
  return scale;
}
